<template>
  <div id="registro" class="zindex10">
    <section id="fondo">
      <div class="container">
        <div class="row pt-5 mb-4">
          <div
            class="col-12 pb-4 zindex10"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            &nbsp;
          </div>
        </div>
        <div class="row py-3">
          <div
            class="col-12 pb-4 zindex10"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            &nbsp;
          </div>
        </div>

        <div class="row">
          <div class="col-12 zindex10">
            <div class="row bgpestana">
              <img
                src="../assets/imgs/datumax/pestana-roja.png"
                alt="pestana"
                class="pestana"
              />

              <div
                class="col-12 bgazuloscuro borderrounded z100 userselectnone"
              >
                <div class="row py-5">
                  <div class="col-12 text-center py-4 pt-5 blanco zindex10">
                    <h2 class="blanco fXG bold">TÉRMINOS Y CONDICIONES</h2>
                  </div>
                </div>

                <div class="row py-1">
                  <div class="col-12 text-center blanco zindex10">
                    <div>
                      <h1>PROMOCIÓN “DA TU MAX”</h1>
                      <p>
                        Sírvase leer cuidadosamente estos Términos y Condiciones
                        antes de participar en la
                        <strong>PROMOCIÓN “Da tu Max”</strong>
                      </p>
                      <p>
                        (en lo sucesivo será denominada la
                        <strong>“PROMOCIÓN</strong>), la cual es una actividad
                        promocional prevista para los Participantes que acumulen
                        puntos mediante el registro de tickets de compra de
                        Productos Participantes en la línea de Cuidado Bucal de
                        Colgate Palmolive, S.A. de C.V., bajo estas condiciones,
                        creada y administrada por
                        <strong> GRUPO PAUTA CREATIVA S.A. DE C.V., </strong>
                        (en lo sucesivo el <strong>“ORGANIZADOR</strong>”) quien
                        puede a su discreción: modificar, enmendar o revisar
                        estos Términos y Condiciones en cualquier momento,
                        siendo el único responsable de la
                        <strong> PROMOCIÓN </strong>
                        .
                      </p>
                      <p>
                        Para participar en la <strong>PROMOCIÓN</strong>se
                        deberá dar lectura íntegra de los siguientes Términos y
                        condiciones (en adelante las “<strong>Bases</strong>”),
                        además de cumplir totalmente con las condiciones aquí
                        establecidas, lo cual implica su total comprensión y
                        aceptación.
                      </p>
                      <p>
                        <strong>COLGATE PALMOLIVE S.A. DE C.V.</strong>y sus
                        subsidiarias o filiales son únicamente el
                        <strong>“PATROCINADOR”</strong>de la
                        <strong> PROMOCIÓN</strong>, por lo que no tienen
                        responsabilidad y/u obligación con la administración y
                        operación de la <strong>PROMOCIÓN</strong>.
                      </p>
                      <h1>1. NATURALEZA DE LA PROMOCIÓN.</h1>
                      <p>
                        La <strong>PROMOCIÓN</strong>se lleva a cabo en términos
                        del artículo 46 de la Ley Federal de Protección al
                        Consumidor. Considerada una promoción de habilidad,
                        destreza y acumulación de puntos conforme a la mecánica
                        descrita más adelante
                      </p>
                      <h1>2. ACEPTACIÓN DE LOS TÉRMINOS Y CONDICIONES.</h1>
                      <p>
                        Al participar en la <strong>PROMOCIÓN</strong>, el
                        Participante acepta quedar obligado por las reglas,
                        interpretación y decisiones del
                        <strong> ORGANIZADOR</strong>, las cuales tendrán
                        carácter definitivo y vinculante respecto de todos los
                        asuntos relacionados con la
                        <strong> PROMOCIÓN </strong>
                        y no admitirán revisión o apelación.
                      </p>
                      <p>
                        Cualquier violación o intento de vulneración a los
                        presentes términos y condiciones, a la Mecánica, reglas
                        de la <strong>PROMOCIÓN</strong>, decisiones del
                        <strong>ORGANIZADOR</strong>, así como a los
                        procedimientos o sistemas establecidos, implicará la
                        inmediata descalificación y exclusión del Participante
                        y/o la revocación del derecho a reclamar cualquiera de
                        los incentivos.
                      </p>
                      <p align="left">
                        <strong>3.</strong
                        ><strong>DENOMINACIÓN DE LA PROMOCIÓN:</strong>“DA TU
                        MAX”
                      </p>
                      <h1>4. RESPONSABLE DE LA PROMOCIÓN Y ORGANIZADOR :</h1>
                      <p>
                        Grupo Pauta Creativa S.A. de C.V., con dirección en
                        Berlín 318 Colonia del Carmen, Alcaldía Coyoacán,
                      </p>
                      <p>
                        C.P. 04100, en Ciudad de México, en un horario de lunes
                        a viernes de las 9:00 a las 18:00 horas, el único
                        responsable y encargado de la ejecución, gestión y
                        entrega de incentivos, tratamiento de datos personales y
                        validación de documentación de Participantes y
                        acreedores al incentivo, así como del uso y/o
                        autorizaciones de uso de los derechos de propiedad
                        intelectual de la <strong>PROMOCIÓN</strong>.
                      </p>
                      <h1>5. VIGENCIA DE LA PROMOCIÓN:</h1>
                      <p>
                        La vigencia de la <strong>PROMOCIÓN</strong>será del 13
                        de octubre a las 00:00 am hasta el 07 de diciembre de
                        2025 a las 11:59 pm, horario de la Ciudad de México.
                      </p>
                      <h1>6. VIGENCIA TICKET DE COMPRA:</h1>
                      <p>
                        Participan los tickets de compra con vigencia a partir
                        del 01 de octubre de 2025 al 07 de diciembre de 2025.
                      </p>
                    </div>
                    <br clear="all" />
                    <div>
                      <p align="left">
                        <strong>7.</strong
                        ><strong>COBERTURA GEOGRÁFICA:</strong>República
                        Mexicana
                      </p>
                      <h1>8. PRODUCTOS PARTICIPANTES:</h1>
                      <p align="left">
                        Para que la participación sea valida, el ticket debe de
                        contener por lo menos 1 (un) producto de la línea Max
                        Fresh® y 1(un) producto de la línea de Cuidado Bucal de
                        Colgate, es decir mínimo 2 (dos) productos:
                      </p>
                      <table border="1" cellspacing="0" cellpadding="0" class="table-striped">
                        <tbody>
                          <tr>
                            <td width="235" valign="top">
                              <p>Pasta Dental</p>
                            </td>
                            <td width="12" rowspan="35" valign="top"></td>
                            <td width="303" valign="top">
                              <p>Enjuagues Bucales</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="235" valign="top">
                              <p>Pasta Dental Colgate Max Fresh</p>
                            </td>
                            <td width="303" valign="top">
                              <p>Enjuague Bucal Plax</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="235" valign="top">
                              <p>Pasta Dental Colgate Max White</p>
                            </td>
                            <td width="303" valign="top">
                              <p>Enjuague Bucal Total</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="235" valign="top">
                              <p>Pasta Dental Colgate Luminous White</p>
                            </td>
                            <td width="303" valign="top">
                              <p>Enjuague Bucal Luminous White</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="235" valign="top">
                              <p>Pasta Dentral Colgate Total</p>
                            </td>
                            <td width="303" valign="top">
                              <p>Enjuague Bucal Periogard</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="235" valign="top">
                              <p>Pasta Dental Colgate Triple Acción</p>
                            </td>
                            <td width="303" valign="top">
                              <p>Enjuague Bucal Orthogard</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="235" valign="top">
                              <p>
                                Pasta Dental Colgate Triple Acción Extra
                                Blancura
                              </p>
                            </td>
                            <td width="303" valign="top">
                              <p>Enjuague Bucal Colgate Plax Kids Minions</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="235" valign="top">
                              <p>
                                Pasta Dental Colgate Triple Acción Extra
                                Frescura
                              </p>
                            </td>
                            <td width="303" valign="top"></td>
                          </tr>
                          <tr>
                            <td width="235" valign="top">
                              <p>Pasta Dental Colgate Max Clean</p>
                            </td>
                            <td width="303" valign="top">
                              <p>Cepillos Manuales</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="235" valign="top">
                              <p>
                                Pasta Dental Colgate Máxima Protección
                                Anticaries
                              </p>
                            </td>
                            <td width="303" valign="top">
                              <p>Colgate Encías Therapy</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="235" valign="top">
                              <p>Pasta Dental Colgate Natural Extracts</p>
                            </td>
                            <td width="303" valign="top">
                              <p>Colgate Encías Therapy Charcoal</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="235" valign="top">
                              <p>Pasta Dental Colgate Sensitive</p>
                            </td>
                            <td width="303" valign="top">
                              <p>Colgate Recyclean</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="235" valign="top">
                              <p>Pasta Dental Colgate Sensitive Pro Alivio</p>
                            </td>
                            <td width="303" valign="top">
                              <p>Colgate Total Limpieza Espumosa</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="235" valign="top">
                              <p>Pasta Dental Colgate Periogard</p>
                            </td>
                            <td width="303" valign="top">
                              <p>Colgate Total Whitening</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="235" valign="top">
                              <p>Pasta Dentarl Colgate Orthogard</p>
                            </td>
                            <td width="303" valign="top">
                              <p>Colgate 360° Base</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="235" valign="top">
                              <p>Pasta Dental Colgate Minions</p>
                            </td>
                            <td width="303" valign="top">
                              <p>Colgate 360° White</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="235" valign="top">
                              <p>Pasta Dental Colgate Kids Tandy</p>
                            </td>
                            <td width="303" valign="top">
                              <p>Colgate 360° Charcoal</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="235" valign="top">
                              <p>Pasta Dental Colgate Justice League</p>
                            </td>
                            <td width="303" valign="top">
                              <p>Colgate Slim Soft</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="235" valign="top">
                              <p>Pasta Dental Colgate Kids My First</p>
                            </td>
                            <td width="303" valign="top">
                              <p>Colgate Pro Cuidado</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="235" valign="top">
                              <p>Pasta Dental Tom's of Maine</p>
                            </td>
                            <td width="303" valign="top">
                              <p>Colgate Pro Cuidado Charcoal</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="235" valign="top"></td>
                            <td width="303" valign="top">
                              <p>Colgate Zig Zag Charcoal</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="235" valign="top">
                              <p>Cepillos Electricos</p>
                            </td>
                            <td width="303" valign="top">
                              <p>Colgate Max White Charcoal</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="235" valign="top">
                              <p>Philips Colgate SonicPro for Kids</p>
                            </td>
                            <td width="303" valign="top">
                              <p>Colgate TA Xtra Whitening</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="235" valign="top">
                              <p>Philips Colgate SonicPro 10</p>
                            </td>
                            <td width="303" rowspan="2" valign="top">
                              <p>
                                Colgate Kit Portartil (Pasta dental Colgate
                                Máxima Protección Anticaries + Cepillo Dental
                                Portatil)
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td width="235" valign="top">
                              <p>Philips Colgate SonicPro 20</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="235" valign="top">
                              <p>Philips Colgate SonicPro 35</p>
                            </td>
                            <td width="303" valign="top">
                              <p>Colgate Twister</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="235" valign="top">
                              <p>Philips Colgate SonicPro 50</p>
                            </td>
                            <td width="303" valign="top">
                              <p>Colgate Premier</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="235" valign="top">
                              <p>Philips Colgate SonicPro 70</p>
                            </td>
                            <td width="303" valign="top">
                              <p>Colgate Triple Acción</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="235" valign="top">
                              <p>Philips Colgate Refills para niños</p>
                            </td>
                            <td width="303" valign="top">
                              <p>Colgate Extra Clean</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="235" valign="top">
                              <p>Philips Colgate Refills Blanqueamiento</p>
                            </td>
                            <td width="303" valign="top">
                              <p>Colgate Super Flexi</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="235" valign="top">
                              <p>Philips Colgate Refills Limpieza Profunda</p>
                            </td>
                            <td width="303" valign="top">
                              <p>Colgate Double Action</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="235" valign="top">
                              <p>
                                Philips Colgate Refills Encía Saludable +
                                Limpieza Profunda
                              </p>
                            </td>
                            <td width="303" valign="top">
                              <p>Colgate Smiles Minions</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="235" valign="top"></td>
                            <td width="303" valign="top">
                              <p>Colgate Smiles Batman and Wonder Woman</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="235" valign="top">
                              <p>Hilo Dental e Interdentales</p>
                            </td>
                            <td width="303" valign="top">
                              <p>Colgate Tandy</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="235" valign="top">
                              <p>Hilo Dental Natural Extracts</p>
                            </td>
                            <td width="303" valign="top">
                              <p>
                                Cepilo Dental Colgate XP Twsiter + Pasta Dental
                                Colgate Triple Acción
                              </p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <br clear="all" />
                    <div>
                      <table border="1" cellspacing="0" cellpadding="0" class="table-striped">
                        <tbody>
                          <tr>
                            <td width="235" valign="top">
                              <p>Hilo Dental Colgate Total</p>
                            </td>
                            <td width="12" valign="top"></td>
                            <td width="303" valign="top">
                              <p>
                                Cepillo Dental XP Triple Acción + Pasta Dental
                                Colgate Triple Acción
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td width="235" valign="top">
                              <p>Cepillo Colgate Interdental</p>
                            </td>
                            <td width="12" valign="top"></td>
                            <td width="303" valign="top"></td>
                          </tr>
                        </tbody>
                      </table>
                      <h1>9. ESTABLECIMIENTOS PARTICIPANTES:</h1>
                      <table border="1" cellspacing="0" cellpadding="0" class="table-striped">
                        <tbody>
                          <tr>
                            <td width="548" colspan="2" valign="top">
                              <p align="center">Tiendas de Autoservicio</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="255" valign="top">
                              <p>Walmart Supercenter</p>
                            </td>
                            <td width="293" valign="top">
                              <p>Ley (Casa Ley)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="255" valign="top">
                              <p>Walmart Express</p>
                            </td>
                            <td width="293" valign="top">
                              <p>Casa Ley Hiper</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="255" valign="top">
                              <p>Bodega Aurrerá</p>
                            </td>
                            <td width="293" valign="top">
                              <p>Casa Ley Súper</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="255" valign="top">
                              <p>Mi Bodega</p>
                            </td>
                            <td width="293" valign="top">
                              <p>Casa Ley Express</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="255" valign="top">
                              <p>Bodega Aurrerá Express</p>
                            </td>
                            <td width="293" valign="top">
                              <p>S-Mart</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="255" valign="top">
                              <p>Chedraui</p>
                            </td>
                            <td width="293" valign="top">
                              <p>alsuper</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="255" valign="top">
                              <p>Chedraui Selecto</p>
                            </td>
                            <td width="293" valign="top">
                              <p>Del Sol</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="255" valign="top">
                              <p>La Comer</p>
                            </td>
                            <td width="293" valign="top">
                              <p>Del Sol Woolworth</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="255" valign="top">
                              <p>Fresko</p>
                            </td>
                            <td width="293" valign="top">
                              <p>Woolworth</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="255" valign="top">
                              <p>City Market</p>
                            </td>
                            <td width="293" valign="top">
                              <p>Caliexpress</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="255" valign="top">
                              <p>Soriana Hiper</p>
                            </td>
                            <td width="293" valign="top">
                              <p>Bodegón (Calimax)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="255" valign="top">
                              <p>Soriana Super</p>
                            </td>
                            <td width="293" valign="top">
                              <p>Aprecio (Calimax)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="255" valign="top">
                              <p>Soriana Mercado</p>
                            </td>
                            <td width="293" valign="top">
                              <p>Calimax</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="255" valign="top">
                              <p>Soriana Express</p>
                            </td>
                            <td width="293" valign="top">
                              <p>Calimax Plux</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="255" valign="top">
                              <p>HEB</p>
                            </td>
                            <td width="293" valign="top"></td>
                          </tr>
                          <tr>
                            <td width="255" valign="top">
                              <p>Mi Tienda (HEB)</p>
                            </td>
                            <td width="293" valign="top"></td>
                          </tr>
                          <tr>
                            <td width="548" colspan="2" valign="top">
                              <p align="center">Farmacias</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="548" colspan="2" valign="top">
                              <p>Súper Farmacia Guadalajara</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="255" valign="top">
                              <p>
                                <strong>Tiendas Mayoristas</strong>
                                <strong></strong>
                              </p>
                            </td>
                            <td width="293" valign="top">
                              <p>
                                <strong>Nombre Comercial</strong>
                                <strong></strong>
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td width="255" valign="top">
                              <p>Distrib El Florido</p>
                            </td>
                            <td width="293" valign="top">
                              <p>El Florido</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="255" valign="top">
                              <p>Frutería Welton</p>
                            </td>
                            <td width="293" valign="top">
                              <p>Frutería Welton</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="255" valign="top">
                              <p>Almacenes Ibarra</p>
                            </td>
                            <td width="293" valign="top">
                              <p>Su Bodega!</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="255" valign="top">
                              <p>Abarrotes Chuper Negro</p>
                            </td>
                            <td width="293" valign="top">
                              <p>Chuper Negro</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="255" rowspan="3" valign="top">
                              <p>
                                <strong></strong>
                              </p>
                              <p>
                                <strong></strong>
                              </p>
                              <p>Abarrotera el Duero</p>
                            </td>
                            <td width="293" valign="top">
                              <p>Bodega La Favorita (Abarrotera del Duero)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="293" valign="top">
                              <p>Super Lagunitas (Abarrotera del Duero)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="293" valign="top">
                              <p>Merza (Abarrotera del Duero)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="255" valign="top">
                              <p>Abar Monterrey</p>
                            </td>
                            <td width="293" valign="top">
                              <p>Abarrotes Monterrey</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="255" valign="top">
                              <p>Scorpion</p>
                            </td>
                            <td width="293" valign="top">
                              <p>Scorpion</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="255" valign="top">
                              <p>Grupo Rivera</p>
                            </td>
                            <td width="293" valign="top">
                              <p>Gran Bodega Siempre Ahorro</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="255" valign="top">
                              <p>Mini Abastos</p>
                            </td>
                            <td width="293" valign="top">
                              <p>Mini Abastos</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="255" valign="top">
                              <p>Proveedora del Panadero</p>
                            </td>
                            <td width="293" valign="top">
                              <p>Abarrotes Dunosusa</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="255" valign="top">
                              <p>Abarrotera Sánchez</p>
                            </td>
                            <td width="293" valign="top">
                              <p>Súper Sánchez</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="255" valign="top">
                              <p>Grupo Zorro Abarrotero</p>
                            </td>
                            <td width="293" valign="top">
                              <p>Zorro Abarrotero</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="255" valign="top">
                              <p>Abastecedora De Abarrotes Z</p>
                            </td>
                            <td width="293" valign="top">
                              <p>Piticó</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="255" valign="top">
                              <p>Garis</p>
                            </td>
                            <td width="293" valign="top">
                              <p>Garis</p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <br clear="all" />
                    <div>
                      <table border="1" cellspacing="0" cellpadding="0" class="table-striped">
                        <tbody>
                          <tr>
                            <td width="255" valign="top">
                              <p>Central Mayorista</p>
                            </td>
                            <td width="293" valign="top">
                              <p>El Mayorista Mercado</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="255" valign="top">
                              <p>Abar. Mendez Serrano</p>
                            </td>
                            <td width="293" valign="top">
                              <p>Méndez Serrano</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="255" valign="top">
                              <p>Comercializadora Mayorista</p>
                            </td>
                            <td width="293" valign="top">
                              <p>Willys</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="255" valign="top">
                              <p>Decasa</p>
                            </td>
                            <td width="293" valign="top">
                              <p>Básicos</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="255" rowspan="3" valign="top">
                              <p>
                                <strong></strong>
                              </p>
                              <p>
                                <strong></strong>
                              </p>
                              <p>Iberia Vecinos (CVS)</p>
                            </td>
                            <td width="293" valign="top">
                              <p>Super Iberia</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="293" valign="top">
                              <p>Super Iberia Vecinos</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="293" valign="top">
                              <p>Vecino Cocina</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="255" valign="top">
                              <p>Abarrotera Ávila</p>
                            </td>
                            <td width="293" valign="top">
                              <p>Super Ávila</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="255" valign="top">
                              <p>Comercial de Carnes Frias</p>
                            </td>
                            <td width="293" valign="top">
                              <p>Mercados Super Chivas</p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <p align="left">
                        <strong></strong>
                      </p>
                      <p align="left">
                        <strong>10.</strong><strong>CONSULTA</strong
                        ><strong></strong><strong>LOS</strong>
                        <strong>TÉRMINOS Y CONDICIONES EN:</strong>
                      </p>
                      <p align="left">
                        Los Términos y Condiciones se encuentran disponibles en
                        la página web:
                        <a href="https://www.datumax.com.mx/">
                          <u>https://www.datumax.com.mx</u>
                        </a>
                      </p>
                      <p>
                        En caso de cualquier actualización de los Términos y
                        Condiciones la página será la misma por lo que se
                        solicita que el Participante consulte periódicamente el
                        sitio web.
                      </p>
                      <h1>11. REQUISITOS PARA PARTICIPAR:</h1>
                      <p align="left">Los requisitos para participar son:</p>
                      <p align="left">- Ser mayor de edad</p>
                      <p align="left">
                        - Ser residente en la República Mexicana
                      </p>
                      <p align="left">
                        - Comprar en 1 (un) solo ticket al menos 2 (dos)
                        productos Participantes donde:
                      </p>
                      <p>
                        ● 1 (uno) de estos productos debe ser forzosamente
                        cualquier Producto Participante de la línea Colgate Max
                        Fresh® y el otro será a elección del Participante; es
                        decir, el Participante deberá comprar 1 (uno) o más
                        productos de la línea Colgate Max Fresh® y 1(uno) o más
                        Productos Participantes de la línea de Cuidado Bucal de
                        Colgate.
                      </p>
                      <h1>12. PLATAFORMAS DE REGISTRO DE PARTICIPANTES:</h1>
                      <p align="left">
                        El Participante podrá registrarse mediante:
                      </p>
                      <p align="left">
                        a. El sitio Web
                        <a
                          href="https://nam04.safelinks.protection.outlook.com/?url=http%3A%2F%2Fwww.datumax.com.mx%2F&amp;data=05%7C02%7Clrosas%40pautacreativa.com.mx%7C11ab11a2d4e8426ae0b308dde3f9fa66%7Cf66d08fc40a84bb89bb158b24c4576bc%7C0%7C0%7C638917384974361294%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&amp;sdata=K5Q1w4OSvJkBI5ooujaVA1clkRVR99SwmM0A4MZw8Oo%3D&amp;reserved=0"
                        >
                          www.datumax.com.mx
                        </a>
                      </p>
                      <p align="left">
                        b. Mediante la plataforma de WhatsApp a través de los
                        links
                        <a href="https://wa.link/pxun4f">
                          https://wa.link/pxun4f
                        </a>
                        con número 5620292918 o
                        <a href="https://wa.link/mtzlwe">
                          https://wa.link/mtzlwe
                        </a>
                        con número 5620298631.
                      </p>
                      <h1>13. INCENTIVOS DE LA PROMOCIÓN:</h1>
                      <p>
                        Existirán un total de 979 (novecientos setenta y nueve)
                        incentivos entregables para los Participantes que
                        resulten ganadores de la <strong> PROMOCIÓN</strong>,
                        siempre y cuando cumplan con cada una de las
                        condiciones, requisitos y mecánica indicados dentro de
                        los presentes Términos y Condiciones y que no incurran
                        en algún supuesto de descalificación, los cuales se
                        asignarán al final de la vigencia de la
                        <strong>PROMOCIÓN</strong>de acuerdo con la siguiente
                        tabla:
                      </p>
                      <table border="1" cellspacing="0" cellpadding="0" class="table-striped">
                        <tbody>
                          <tr>
                            <td width="101" valign="top">
                              <p>
                                <strong>PERIODO DE PARTICIPACIÓN</strong>
                                <strong> </strong>
                              </p>
                            </td>
                            <td width="116" valign="top">
                              <p>
                                <strong>VIGENCIA DE PARTICIPACIÓN</strong>
                                <strong> </strong>
                              </p>
                            </td>
                            <td width="61" valign="top">
                              <p align="center">
                                <strong>LUGAR</strong> <strong></strong>
                              </p>
                            </td>
                            <td width="267" valign="top">
                              <p align="center">
                                <strong>INCENTIVOS</strong> <strong></strong>
                              </p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">
                                <strong>TOTAL</strong><strong></strong
                                ><strong>INCENTIVOS</strong><strong></strong
                                ><strong>POR</strong><strong></strong
                                ><strong>PERIODO</strong>
                                <strong></strong>
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td width="101" rowspan="4" valign="top">
                              <p>PERIODO 1</p>
                            </td>
                            <td width="116" rowspan="4" valign="top">
                              <p align="center">13 DE OCTUBRE AL</p>
                              <p align="center">26 DE OCTUBRE DE</p>
                              <p align="center">2025</p>
                            </td>
                            <td width="61" valign="top">
                              <p align="center">1° Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>iPhone 17 Pro de 256 GB CON CASE DE MUNDIAL</p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">1 (uno)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p>2° al 4° Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>Pantallas de 65" Smart TV</p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">3 (tres)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p align="center">5° Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>
                                Boletos Partidos amistosos en MX | Acceso VIP
                              </p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">1 (uno)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p>6° al 10°</p>
                              <p>Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>
                                Boletos Partidos amistosos en MX | Acceso
                                Preferente
                              </p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">5(cinco)</p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <br clear="all" />
                    <div>
                      <table border="1" cellspacing="0" cellpadding="0" class="table-striped">
                        <tbody>
                          <tr>
                            <td width="101" rowspan="14" valign="top"></td>
                            <td width="116" rowspan="14" valign="top"></td>
                            <td width="61" valign="top">
                              <p align="center">11° al 15°</p>
                              <p align="center">Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>
                                Boletos Partidos amistosos en MX | Acceso
                                General
                              </p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">5 (cinco)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p align="center">16° al 17°</p>
                              <p align="center">Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>
                                Experiencia en evento privado en Alboa en Ciudad
                                de México (1 premio con un pase doble)
                              </p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">2 (dos)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p align="center">18° al 22°</p>
                              <p align="center">Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>Balón marca Adidas World Cup PRO</p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">5 (cinco)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p align="center">23° al 27°</p>
                              <p align="center">Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>
                                Jersey Adidas Selección Nacional Mexicana color
                                verde
                              </p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">5 (cinco)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p align="center">28° al 42°</p>
                              <p align="center">Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>
                                Playeras de la Selección Nacional Mexicana
                                autografiada jugadores
                              </p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">15 (quince)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p align="center">43° al 57°</p>
                              <p align="center">Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>Playeras de la Selección Nacional Mexicana</p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">15 (quince)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p align="center">58° al 59°</p>
                              <p align="center">Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>
                                Playeras de la Selección Nacional Mexicana
                                utilizada en un partido de la Selección Nacional
                                Mexicana y autografiada
                              </p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">2 (dos)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p align="center">60° Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>
                                Experiencia visita en Centro de alto rendimiento
                                en Cdmx para ver entrenamiento de la SNM (1
                                premio con pase doble)
                              </p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">1 (uno)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p align="center">61° al 70°</p>
                              <p align="center">Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>Hoodie marca Adidas - World Cup color verde</p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">10 (diez)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p align="center">71° al 80°</p>
                              <p align="center">Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>Balón marca Adidas World Cup competition</p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">10 (diez)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p align="center">81° al 90°</p>
                              <p align="center">Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>Hoodie Adidas DNA color verde</p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">10 (diez)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p align="center">91° al 100°</p>
                              <p align="center">Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>Sudadera Adidas DNA crew sweat color verde</p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">10 (diez)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p align="center">101° al</p>
                              <p align="center">110° Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>Sudadera Adidas DNA crew sweat color ivory</p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">10 (diez)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p align="center">111° al</p>
                              <p align="center">270° Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>
                                Playera Adidas Selección Nacional Mexicana -
                                genérica hombre tamaño regular
                              </p>
                            </td>
                            <td width="80" valign="top">
                              <p>160 (ciento sesenta)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="101" rowspan="17" valign="top">
                              <p>PERIODO 2</p>
                            </td>
                            <td width="116" rowspan="17" valign="top">
                              <p align="center">27 DE OCTUBRE AL</p>
                              <p align="center">09 DE NOVIEMBRE</p>
                              <p align="center">DE 2025</p>
                            </td>
                            <td width="61" valign="top">
                              <p align="center">1° Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>iPhone 17 Pro de 256 GB CON CASE DE MUNDIAL</p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">1 (uno)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p>2° al 4° Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>Pantallas de 65" Smart TV</p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">3 (tres)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p align="center">5° Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>
                                Boletos Partidos amistosos en MX | Acceso VIP
                              </p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">1 (uno)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p>6° al 10°</p>
                              <p>Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>
                                Boletos Partidos amistosos en MX | Acceso
                                Preferente
                              </p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">5 (cinco)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p align="center">11° al 15°</p>
                              <p align="center">Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>Boletos Partidos amistosos en MX | Acceso</p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">5 (cinco)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p align="center">16° AL 20°</p>
                              <p align="center">Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>Balón marca Adidas World Cup PRO</p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">5 (cinco)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p align="center">21° al 25°</p>
                              <p align="center">Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>
                                Jersey Adidas Selección Nacional Mexicana color
                                verde
                              </p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">5 (cinco)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p align="center">26° al 75°</p>
                              <p align="center">Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>
                                Playeras de la Selección Nacional Mexicana
                                autografiada jugadores
                              </p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">50 (cincuenta)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p align="center">76° al 125°</p>
                              <p align="center">Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>Playeras de la Selección Nacional Mexicana</p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">50 (cincuenta)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p align="center">126° al</p>
                              <p align="center">127° Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>
                                Playeras de la Selección Nacional Mexicana
                                utilizada en un partido de la Selección Nacional
                                Mexicana y autografiada
                              </p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">2 (dos)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p align="center">128° Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>
                                Experiencia visita en Centro de alto rendimiento
                                en CDMX para ver entrenamiento de la SNM (1
                                premio con pase doble)
                              </p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">1(un)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p align="center">129° al</p>
                              <p align="center">138° Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>Hoodie marca Adidas - World Cup color verde</p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">10 (diez)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p align="center">139° al</p>
                              <p align="center">148° Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>Balón marca Adidas World Cup competition</p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">10 (diez)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p align="center">149° al</p>
                              <p align="center">158° Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>Hoodie Adidas DNA color verde</p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">10 (diez)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p align="center">159° al</p>
                              <p align="center">168° Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>Sudadera Adidas DNA crew sweat color verde</p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">10 (diez)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p align="center">169° al</p>
                              <p align="center">178° Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>Sudadera Adidas DNA crew sweat color ivory</p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">10 (diez)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p align="center">179° al</p>
                              <p align="center">338° Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>
                                Playera Adidas Selección Nacional Mexicana -
                                genérica hombre tamaño regular
                              </p>
                            </td>
                            <td width="80" valign="top">
                              <p>160 (ciento sesenta)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="101" rowspan="3" valign="top">
                              <p>PERIODO 3</p>
                            </td>
                            <td width="116" rowspan="3" valign="top">
                              <p align="center">10 DE NOVIEMBRE</p>
                              <p align="center">AL 23 DE</p>
                              <p align="center">NOVIEMBRE DE 2025</p>
                            </td>
                            <td width="61" valign="top">
                              <p align="center">1° Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>iPhone 17 Pro de 256 GB CON CASE DE MUNDIAL</p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">1(uno)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p>2° al 4° Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>Pantallas de 65" Smart TV</p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">3 (tres)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p align="center">5° Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>
                                Boletos Partidos amistosos en MX | Acceso VIP
                              </p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">1 (uno)</p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <br clear="all" />
                    <div>
                      <table border="1" cellspacing="0" cellpadding="0" class="table-striped">
                        <tbody>
                          <tr>
                            <td width="101" rowspan="15" valign="top"></td>
                            <td width="116" rowspan="15" valign="top"></td>
                            <td width="61" valign="top">
                              <p>6° al 10°</p>
                              <p>Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>
                                Boletos Partidos amistosos en MX | Acceso
                                Preferente
                              </p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">5 (cinco)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p align="center">11° al 15°</p>
                              <p align="center">Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>
                                Boletos Partidos amistosos en MX | Acceso
                                General
                              </p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">5 (cinco)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p align="center">16° AL 20°</p>
                              <p align="center">Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>Balón marca Adidas World Cup PRO</p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">5 (cinco)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p align="center">21° al 25°</p>
                              <p align="center">Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>
                                Jersey Adidas Selección Nacional Mexicana color
                                verde
                              </p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">5 (cinco)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p align="center">26° al 75°</p>
                              <p align="center">Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>
                                Playeras de la Selección Nacional Mexicana
                                autografiada jugadores
                              </p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">50 (cincuenta)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p align="center">76° al 125°</p>
                              <p align="center">Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>Playeras de la Selección Nacional Mexicana</p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">50 (cincuenta)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p align="center">126° Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>
                                Playeras de la Selección Nacional Mexicana
                                utilizada en un partido de la Selección Nacional
                                Mexicana y autografiada
                              </p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">1 (uno)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p align="center">127° Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>
                                Experiencia visita en Centro de alto rendimiento
                                en Cdmx para ver entrenamiento de la SNM (1
                                premio con pase doble)
                              </p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">1 (uno)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p align="center">128° al</p>
                              <p align="center">137° Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>Hoodie marca Adidas - World Cup color verde</p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">10 (diez)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p align="center">138° al</p>
                              <p align="center">147° Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>Balón marca Adidas World Cup competition</p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">10 (diez)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p align="center">148° al</p>
                              <p align="center">149° Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>Balones usados y autografiados</p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">2 (dos)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p align="center">150° al</p>
                              <p align="center">159° Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>Hoodie Adidas DNA color verde</p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">10 (diez)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p align="center">160° al</p>
                              <p align="center">169° Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>Sudadera Adidas DNA crew sweat color verde</p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">10 (diez)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p align="center">170° al</p>
                              <p align="center">179° Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>Sudadera Adidas DNA crew sweat color ivory</p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">10 (diez)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p align="center">180° al</p>
                              <p align="center">359° Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>
                                Playera Adidas Selección Nacional Mexicana -
                                genérica hombre tamaño regular
                              </p>
                            </td>
                            <td width="80" valign="top">
                              <p>180 (ciento ochenta)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="101" rowspan="5" valign="top">
                              <p>PREMIO FINAL</p>
                            </td>
                            <td width="116" rowspan="5" valign="top">
                              <p align="center">13 DE OCTUBRE AL</p>
                              <p align="center">07 DE DICIEMBRE DE</p>
                              <p align="center">2025</p>
                            </td>
                            <td width="61" valign="top">
                              <p>1° al 2°</p>
                              <p>Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>
                                2 boletos al mundial para el Partido 1 – Grupo A
                                (México
                              </p>
                              <p>#1) - Estadio Azteca Ciudad de México</p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">2 (dos)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p>3° al 4° Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>
                                2 boletos al mundial para el Partido 53 – Grupo
                                A (México #3) - Estadio Azteca Ciudad de México
                              </p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">2 (dos)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p>5° al 6°</p>
                              <p>Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>
                                2 boletos al mundial para el Partido 12 – Grupo
                                F - Estadio
                              </p>
                              <p>Monterrey</p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">2 (dos)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p align="center">7° Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>Certificado con valor de $30,000.00 MX</p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">1 (uno)</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="61" valign="top">
                              <p>8° al 12°</p>
                              <p>Lugar</p>
                            </td>
                            <td width="267" valign="top">
                              <p>
                                Paquete doble para presenciar un partido
                                amistoso de la Selección Nacional Mexicana de
                                futbol varonil mayor en los Estados Unidos de
                                America. Incluye: 2 boletos de avión, hospedaje
                                en la mejor categoría disponible, 2 boletos de
                                estadio categoría 1(uno) o 2 (dos) sujeto a
                                disponibilidad, transportación terrestre
                                aeropuerto - hotel - estadio - hotel aeropuerto
                              </p>
                            </td>
                            <td width="80" valign="top">
                              <p align="center">5 (cinco)</p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <p>
                        Estos incentivos podrán ser sustituidos en caso de falta
                        de inventario por marcas o modelos semejantes con
                        especificaciones de uso iguales o equivalentes, el
                        Participante que resulte seleccionado para dicho
                        incentivo (en adelante “Ganador”o “Ganadores”) será
                        contactado mediante los datos de contacto que hayan sido
                        proporcionados en el Registro para que pueda seleccionar
                        de un incentivo diferente de no tener disponibilidad del
                        ofertado inicialmente.
                      </p>
                      <p>
                        Las garantías a los incentivos ofrecidos se harán
                        válidos conforme a las condiciones que cada proveedor
                        y/o fabricante ofrezca dentro de la documentación
                        contenida en los empaques o términos de uso.
                      </p>
                      <h1>14. MECÁNICA DE PARTICIPACIÓN:</h1>
                      <p align="left">
                        <strong></strong>
                      </p>
                      <p>
                        a) Quien desee participar deberá cumplir a cabalidad los
                        requisitos de participación que se establecen los
                        presentes Términos y Condiciones que podrán ser
                        consultados en
                        <a href="https://www.datumax.com.mx/">
                          https://www.datumax.com.mx
                        </a>
                      </p>
                      <p>
                        b) Para poder participar en la
                        <strong>PROMOCIÓN</strong>, el Participante podrá elegir
                        cualquiera de las plataformas de registro; sitio web
                        <a
                          href="https://nam04.safelinks.protection.outlook.com/?url=http%3A%2F%2Fwww.datumax.com.mx%2F&amp;data=05%7C02%7Clrosas%40pautacreativa.com.mx%7C11ab11a2d4e8426ae0b308dde3f9fa66%7Cf66d08fc40a84bb89bb158b24c4576bc%7C0%7C0%7C638917384974361294%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&amp;sdata=K5Q1w4OSvJkBI5ooujaVA1clkRVR99SwmM0A4MZw8Oo%3D&amp;reserved=0"
                        >
                          www.datumax.com.mx
                        </a>
                        o por la plataforma WhatsApp a través de los links
                        https://wa.link/pxun4f con número 5620292918 o
                        https://wa.link/mtzlwe con número 5620298631 y completar
                        su registro correctamente:
                      </p>
                    </div>
                    <br clear="all" />
                    <div>
                      <h2>I. Registro vía WhatsApp:</h2>
                      <p>
                        El Participante deberá iniciar una conversación con el
                        chatbot de WhatsApp, enviando un mensaje a través de los
                        links https://wa.link/pxun4f con número 5620292918 o
                        https://wa.link/mtzlwe con número 5620298631, aceptar
                        los términos y condiciones, aviso de Privacidad y
                        confirmar ser mayor de edad y seguir detalladamente las
                        instrucciones para completar su registro, en el que
                        deberá compartir: su nombre completo, teléfono y correo
                        electrónico.
                      </p>
                      <p>
                        Al registrar sus datos correctamente se le asignará un
                        número de usuario Participante. Posteriormente deberá
                        enviar una fotografía legible de su ticket de compra que
                        cumpla con los Términos y Condiciones de la
                        <strong>PROMOCIÓN</strong>. La vigencia del ticket de
                        compra válida será a partir del 01 de octubre al 07 de
                        diciembre de 2025.
                      </p>
                      <h2 align="left">II. Registro vía sitio Web:</h2>
                      <p align="left">
                        El Participante deberá entrar al sitio web
                        <a href="http://www.datumax.com.mx/">
                          www.datumax.com.mx
                        </a>
                        y deberá crear su usuario en el botón "Quiero
                        registrarme" y después compartiendo: su nombre completo,
                        teléfono y correo electrónico Posteriormente deberá
                        aceptar los términos y condiciones, aviso de privacidad
                        y confirmar ser mayor de edad, al registrar sus datos
                        correctamente se creará el perfil de participación.
                      </p>
                      <p>
                        El Participante deberá subir una fotografía legible de
                        su ticket de compra que cumpla con las condiciones de la
                        <strong>PROMOCIÓN</strong>. La vigencia del ticket de
                        compra válida será a partir del 01 de octubre al 07 de
                        diciembre de 2025.
                      </p>
                      <p>
                        c) Una vez que el ticket de compra sea validado
                        correctamente en un tiempo máximo 48 (cuarenta y ocho)
                        horas hábiles, el Participante recibirá por el mismo
                        medio, la confirmación de su registro y número de puntos
                        acumulados hasta el momento. La captura y validación de
                        los tickets de compra registrados en esta
                        <strong>PROMOCIÓN</strong>se realiza a través de la
                        aplicación Veryfi, tecnología especializada que
                        garantiza la autenticidad de los tickets.
                      </p>
                      <p>
                        d) El ticket de compra deberá contener al menos 2 (dos)
                        Productos Participantes mencionados en el
                        <strong>Punto 7</strong>(es decir, 1 (uno) o más
                        productos de la línea Colgate Max Fresh® y 1(uno) o más
                        Productos Participantes de la línea de Cuidado Bucal de
                        Colgate) y disponibles en los establecimientos
                        Participantes mencionados en el
                        <strong>Punto 8,</strong>de acuerdo con la siguiente
                        distribución:
                      </p>
                      <p>
                        I. Por la compra de uno (1) o más productos de la marca
                        Colgate Max Fresh®, el Participante acumulará puntos
                        equivalentes a diez (10) veces el valor en pesos de
                        dichos productos. Es decir, por cada peso ($1.00 un peso
                        00/100 M.N.) gastado en productos Colgate Max Fresh®, se
                        otorgarán diez (10) puntos. Por ejemplo, si el Producto
                        Participante costó $50.00 (cincuenta pesos 00/100 M.N.)
                        el total de puntos acumulados serían 500 (quinientos)
                      </p>
                      <p>
                        II. Por la compra de uno (1) o más Productos
                        Participantes de la línea de Cuidado Bucal Colgate, el
                        Participante acumulará puntos equivalentes al valor en
                        pesos de dichos productos. Es decir, por cada peso
                        ($1.00 un peso 00/100 M.N.) gastado en Productos
                        Participantes de la línea de Cuidado Bucal Colgate, se
                        otorgará un (1) punto. Por ejemplo, Si el Producto
                        Participante costó $50.00 (cincuenta pesos 00/100 M.N.)
                        el total de puntos acumulados serían 50 (cincuenta)
                      </p>
                      <h2 align="left">
                        Cada ticket de compra registrado deberá contar al menos
                        con un (1) Producto Participante de la línea Colgate Max
                        Fresh®
                      </h2>
                      <p align="left">
                        <strong></strong>
                      </p>
                      <p>
                        e) Los Participantes que acumulen la mayor cantidad de
                        puntos durante la vigencia de la
                        <strong>PROMOCIÓN</strong>, podrán ser acreedores a uno
                        de los incentivos de acuerdo con los periodos descritos
                        en el <strong>Punto 13.</strong>
                      </p>
                      <p align="left">
                        <strong></strong>
                      </p>
                      <p>
                        f) No participarán los tickets de compra acumulados o
                        que no alcancen el mínimo de compra en Productos
                        Participantes para poder participar en la
                        <strong>PROMOCIÓN</strong>.
                      </p>
                      <p>
                        g) Los Participantes deberán conservar los tickets de
                        compra en original y en estado legible sin tachaduras,
                        raspaduras ni enmendaduras y que muestren los Productos
                        Participantes registrados, para validar su participación
                        y en su caso, poder ser acreedores al incentivo, los
                        tickets podrán ser solicitados por el
                        <strong>ORGANIZADOR</strong>y/o
                        <strong>PATROCINADOR</strong>y su negativa de entrega
                        anulará la participación en la
                        <strong>PROMOCIÓN</strong>, dejando sin efectos los
                        comprobantes que haya registrado y liberando al
                        <strong> ORGANIZADOR </strong>
                        y/o <strong>PATROCINADOR</strong>de cualquier
                        responsabilidad.
                      </p>
                    </div>
                    <br clear="all" />
                    <div>
                      <h1>15. SELECCIÓN DE ACREEDORES A LOS INCENTIVOS:</h1>
                      <p>
                        La presente <strong>PROMOCIÓN</strong>tendrá un total de
                        979 (novecientos setenta y nueve) incentivos, los cuales
                        se asignarán a los Participantes dependiendo de la
                        cantidad de puntos que hayan acumulado durante la
                        vigencia de la <strong>PROMOCIÓN</strong>y una vez que
                        hayan cumplido con los requisitos de participación de la
                        misma, sin violar ninguna de las restricciones de los
                        presentes términos y condiciones, de acuerdo con los
                        siguientes puntos y periodos de la
                        <strong> PROMOCIÓN </strong>
                        :
                      </p>
                      <p>
                        <strong>Incentivos Periodo 1</strong>: Habrá 270
                        (doscientos setenta) incentivos, que se asignarán a los
                        270 (doscientos setenta) Participantes que hayan
                        acumulado la mayor cantidad puntos acumulados durante la
                        vigencia del
                        <strong>
                          13 DE OCTUBRE AL 26 DE OCTUBRE DE 2025
                        </strong>
                        . Correspondiendo el primer lugar al Participante con la
                        mayor cantidad de puntos acumulados y sucesivamente los
                        siguientes lugares hasta asignar los 270 (doscientos
                        setenta) incentivos mencionados en el
                        <strong>PUNTO 13</strong>, siempre y cuando cumplan con
                        lo establecido en la <strong>PROMOCIÓN</strong>.
                      </p>
                      <p>
                        <strong>Incentivos Periodo 2</strong>: Habrá 338
                        (trescientos treinta y ocho) incentivos, que se
                        asignarán a los 338 (trescientos treinta y ocho)
                        Participantes que hayan acumulado la mayor cantidad
                        puntos acumulados durante la vigencia del
                        <strong>
                          27 DE OCTUBRE AL 09 DE NOVIEMBRE DE 2025.
                        </strong>
                        Correspondiendo el primer lugar al Participante con la
                        mayor cantidad de puntos acumulados y sucesivamente los
                        siguientes lugares hasta asignar los 338 (trescientos
                        treinta y ocho) incentivos mencionados en el
                        <strong>PUNTO 13</strong>, siempre y cuando cumplan con
                        lo establecido en la <strong>PROMOCIÓN</strong>.
                      </p>
                      <p>
                        <strong>Incentivos Periodo 3</strong>: Habrá 359
                        (trescientos cincuenta y nueve) incentivos, que se
                        asignarán a los 359 (trescientos cincuenta y nueve)
                        Participantes que hayan acumulado la mayor cantidad
                        puntos acumulados durante la vigencia
                        <strong>
                          del 10 DE NOVIEMBRE AL 23 DE NOVIEMBRE DE 2025
                        </strong>
                        . Correspondiendo el primer lugar al Participante con la
                        mayor cantidad de puntos acumulados y sucesivamente los
                        siguientes lugares hasta asignar los 359 (trescientos
                        cincuenta y nueve) incentivos mencionados en el
                        <strong>PUNTO 13</strong>, siempre y cuando cumplan con
                        lo establecido en la <strong>PROMOCIÓN</strong>.
                      </p>
                      <h2>
                        Limitado a 1 incentivo por periodo por Participante, un
                        acreedor sólo podrá ganar una vez durante la vigencia de
                        la PROMOCIÓN ya sea en el periodo 1 (uno) o en periodo 2
                        (dos) o en periodo 3 (tres), salvo el premio final
                        siempre y cuando cumpla en su totalidad los presentes
                        términos y condiciones.
                      </h2>
                      <p align="left">
                        <strong></strong>
                      </p>
                      <p>
                        <strong>
                          El Participante podrá acumular sus puntos recolectados
                          durante toda la vigencia de la PROMOCIÓN, siempre y
                          cuando no hubiese resultado ganador en algún Periodo.
                        </strong>
                      </p>
                      <p align="left">
                        <strong></strong>
                      </p>
                      <p>
                        <strong>Incentivo final:</strong>Habrá 12 (doce)
                        incentivos finales a total <strong>PROMOCIÓN</strong>,
                        que se asignarán a los Participantes que
                        <strong>
                          durante toda la vigencia de la PROMOCIÓN QUE ES DEL 13
                          DE OCTUBRE AL 07 DE DICIEMBRE DE 2025
                        </strong>
                        hayan acumulado la mayor cantidad puntos,
                        correspondiendo el primer lugar al Participante con la
                        mayor cantidad puntos acumulados y sucesivamente los
                        siguientes lugares hasta asignar los 12 incentivos
                        mencionados en el <strong>PUNTO 13</strong>, siempre y
                        cuando cumplan con las condiciones de la
                        <strong>PROMOCIÓN</strong>.
                      </p>
                      <p>
                        En caso de existir empate, se declarará acreedor al
                        incentivo que conteste la pregunta correcta sobre los
                        Productos de Colgate. El
                        <strong>ORGANIZADOR</strong>y el
                        <strong>PATROCINADOR</strong>se deslindan de cualquier
                        falla en la plataforma por causas del dispositivo o
                        conexión de internet utilizada por parte del
                        Participante. Se contactará a los finalistas al teléfono
                        celular que brindó en el registro, en un lapso no mayor
                        de 48 (cuarenta y ocho) horas a partir de la primera
                        llamada realizada y contestada personalmente, para que
                        envíen sus documentos y tickets correspondientes al
                        correo que establezca el <strong>ORGANIZADOR</strong>y
                        así validar que es
                      </p>
                    </div>
                    <br clear="all" />
                    <div>
                      <p>
                        acreedor al incentivo correspondiente. En caso de no ser
                        contactados, se le enviará un correo electrónico a la
                        dirección proporcionada durante su registro y contarán
                        con las mismas 48 (cuarenta y ocho) horas a partir de su
                        envío para dar respuesta. En caso de no tener respuesta
                        del Participante por ningún medio en el lapso
                        establecido de 48 (cuarenta y ocho) horas, los
                        incentivos serán asignados al siguiente Participante por
                        el <strong>ORGANIZADOR.</strong>
                      </p>
                      <p align="left">
                        <strong></strong>
                      </p>
                      <p>
                        El carácter de ganador al incentivo solamente se
                        adquiere al ser validados los tickets en línea con los
                        presentes Términos y condiciones.
                      </p>
                      <h1>16. PUBLICACIÓN DE GANADORES:</h1>
                      <p align="left">
                        <strong></strong>
                      </p>
                      <p>
                        Los Participantes que resulten acreedores a los
                        incentivos serán publicados en el sitio web
                        <a href="https://www.datumax.com.mx/">
                          <u>https://www.datumax.com.mx</u>
                        </a>
                        una vez que se haya validado los registros de todos los
                        Participantes de acuerdo con el siguiente calendario:
                      </p>
                      <table border="1" cellspacing="0" cellpadding="0" class="table-striped">
                        <tbody>
                          <tr>
                            <td width="144" valign="top">
                              <p>PERIODO DE PARTICIPACIÓN</p>
                            </td>
                            <td width="312" valign="top">
                              <p>VIGENCIA DE PARTICIPACIÓN</p>
                            </td>
                            <td width="168" valign="top">
                              <p align="center">FECHA DE PUBLICACIÓN</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="144" valign="top">
                              <p align="center">PERIODO 1</p>
                            </td>
                            <td width="312" valign="top">
                              <p>13 DE OCTUBRE AL 26 DE OCTUBRE DE 2025</p>
                            </td>
                            <td width="168" valign="top">
                              <p align="center">05 DE NOVIEMBRE DE 2025</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="144" valign="top">
                              <p align="center">PERIODO 2</p>
                            </td>
                            <td width="312" valign="top">
                              <p>27 DE OCTUBRE AL 09 DE NOVIEMBRE DE 2025</p>
                            </td>
                            <td width="168" valign="top">
                              <p align="center">19 DE NOVIEMBRE DE 2025</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="144" valign="top">
                              <p align="center">PERIODO 3</p>
                            </td>
                            <td width="312" valign="top">
                              <p>10 DE NOVIEMBRE AL 23 DE NOVIEMBRE DE 2025</p>
                            </td>
                            <td width="168" valign="top">
                              <p align="center">03 DE DICIEMBRE DE 2025</p>
                            </td>
                          </tr>
                          <tr>
                            <td width="144" valign="top">
                              <p align="center">PREMIO FINAL</p>
                            </td>
                            <td width="312" valign="top">
                              <p>13 DE OCTUBRE AL 07 DE DICIEMBRE DE 2025</p>
                            </td>
                            <td width="168" valign="top">
                              <p align="center">17 DE DICIEMBRE DE 2025</p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <p>
                        Las fechas de publicación podrán modificarse, en su
                        caso, conforme a la información proporcionada por los
                        finalistas y al tiempo requerido para su validación.
                      </p>
                      <h1>17. ENTREGA DE INCENTIVOS:</h1>
                      <p>
                        Una vez determinado que algún Participante haya
                        resultado acreedor al incentivo será notificado vía
                        telefónica, y/o al correo electrónico que haya
                        registrado, es indispensable que la persona permita ser
                        contactado por el <strong>ORGANIZADOR</strong>quien dará
                        las instrucciones detalladas para la recepción y entrega
                        del incentivo, el horario en el que serán contactados
                        será de lunes a jueves de 09:00 a 18:00 horas y viernes
                        de 09:00 a 15:00 horas y serán contactados mediante
                        llamada telefónica desde el número 5530679900 o bien
                        desde el correo electrónico
                        <a href="mailto:datumax@pautapromocional.com.mx">
                          <u>datumax@pautapromocional.com.mx</u>
                        </a>
                      </p>
                      <p>
                        <strong
                          >Para efectos de la reclamación del incentivo</strong
                        >, los acreedores deberán enviar de manera digital los
                        siguientes documentos:
                      </p>
                      <p align="left">● Ticket(s) de compra registrados</p>
                      <p align="left">● Copia de la CURP</p>
                      <p align="left">
                        ● Copia de una identificación oficial vigente
                      </p>
                      <p align="left">
                        ● Comprobante de domicilio con antigüedad no mayor a
                        3(tres) meses
                      </p>
                      <p>
                        Una vez recibida y validada la documentación, se enviará
                        al acreedor, vía correo electrónico, un recibo de
                        conformidad digital. Dicho recibo deberá ser impreso,
                        firmado en original y devuelto utilizando la guía
                        electrónica prepagada proporcionada por el
                        <strong>ORGANIZADOR,</strong>
                        y en su caso solicitar los tickets de compra originales
                        para validación.
                      </p>
                      <p>
                        El acreedor deberá responder acreditando su identidad en
                        un plazo máximo de cuarenta y ocho (48) horas contadas a
                        partir del requerimiento. En caso de que el Participante
                        proporcione un correo electrónico y/o número telefónico
                        erróneo o incompleto que impida al
                        <strong> ORGANIZADOR </strong>
                        establecer contacto, perderá el derecho a recibir y/o
                        reclamar cualquier incentivo.
                      </p>
                    </div>
                    <br clear="all" />
                    <div>
                      <p>
                        La entrega del incentivo será responsabilidad del
                        <strong> ORGANIZADOR </strong>
                        , en los términos y condiciones descritos; los
                        Participantes declarados acreedores al incentivo deberán
                        seguir las instrucciones del
                        <strong> ORGANIZADOR </strong>
                        enviando sus datos más tardar el día que este establezca
                        y se hayan validado conforme a estas bases.
                      </p>
                      <p>
                        Importante: En caso de que el Participante que haya
                        resultado acreedor del incentivo de la
                        <strong>PROMOCIÓN</strong>no responda cualquiera de las
                        notificaciones en un lapso de 48 (cuarenta y ocho)
                        horas, se tomará al siguiente Participante que haya
                        acumulado el mayor puntaje dentro de la vigencia de la
                        <strong>PROMOCIÓN</strong>conforme a las presentes
                        bases.
                      </p>
                      <p>
                        El carácter de acreedor al incentivo solamente se
                        adquiere al ser validados los tickets de compra
                        registrados como Participantes y cumpla en su totalidad
                        con los presentes Términos y condiciones.
                      </p>
                      <h1>18. RESTRICCIONES:</h1>
                      <p>
                        ● Solo podrán participar únicamente personas mayores de
                        18 (dieciocho) años, cuya mayoría de edad deberá ser
                        comprobable mediante identificación oficial vigente
                        tanto al momento del cierre de la
                        <strong>PROMOCIÓN</strong>como al hacer efectivo el
                        incentivo. El incumplimiento de cualquiera de estos
                        requisitos será motivo de descalificación.
                      </p>
                      <p align="left">
                        ● Solo podrán participar personas que residan dentro de
                        la República Mexicana.
                      </p>
                      <p align="left">
                        ● No válido ni acumulable con otras promociones.
                      </p>
                      <p align="left">
                        ● Limitado a 979 (novecientos setenta y nueve)
                        incentivos en total por toda la
                        <strong>PROMOCIÓN</strong>
                      </p>
                      <p align="left">
                        atendiendo a los incentivos específicos por periodo.
                      </p>
                      <p align="left">
                        ● Los incentivos no podrán canjearse o sustituirse por
                        dinero en efectivo.
                      </p>
                      <p>
                        ● El <strong>ORGANIZADOR</strong>se reserva el derecho
                        de solicitar a los acreedores de los incentivos los
                        originales de los tickets de compra y/o los productos
                        Participantes. El incumplimiento en la entrega de los
                        tickets y/o comprobantes de compra registradas de
                        acuerdo con las presentes bases será motivo de
                        descalificación.
                      </p>
                      <p>
                        ● Los tickets de compra deben ser presentados en
                        original y en estado legible sin tachaduras, raspaduras
                        ni enmendaduras
                      </p>
                      <p>
                        ● El <strong>ORGANIZADOR</strong>y el
                        <strong> PATROCINADOR </strong>
                        no se hacen responsables de la disponibilidad del
                        Producto Participante durante la vigencia de la
                        <strong>PROMOCIÓN</strong>.
                      </p>
                      <p>
                        ● En caso de que un usuario ingrese a registrar sus
                        datos o participar a través del perfil de otro
                        Participante, éste será descalificado de la
                        <strong>PROMOCIÓN</strong>. Entiéndase por DESCALIFICADO
                        que no se entregará ningún incentivo y no podrá seguir
                        participando en la <strong>PROMOCIÓN</strong>.
                      </p>
                      <p>
                        ● Cada participación será considerada a través de una
                        sola cuenta WhatsApp y/o Sitio WEB registrada en la base
                        de datos del
                        <strong>ORGANIZADOR</strong>que será aquella con la que
                        hayan registrado las compras de Producto Participante,
                        en caso de que el
                        <strong> ORGANIZADOR </strong>
                        detecte que un usuario participa con 2 o más cuentas,
                        será descalificado en todas las cuentas detectadas y sus
                        tickets o comprobantes de compra serán anulados de forma
                        permanente y no podrá seguir participando en la
                        <strong>PROMOCIÓN</strong>, ni se hará entrega de
                        incentivos de ningún tipo.
                      </p>
                      <p>
                        ● Los tickets de compra deberán ser auténticos conforme
                        a las consideraciones oficiales de las plataformas
                        Participantes. El
                        <strong> ORGANIZADOR </strong>
                        se reserva el derecho de solicitar validación del
                        <strong> PATROCINADOR </strong>
                        .
                      </p>
                      <p>
                        ● El Participante entiende y acepta que está prohibido
                        violar o intentar violar, de cualquier forma, la
                        seguridad de la información de las plataformas de
                        participación, incluyendo de manera enunciativa y no
                        limitativa, hackeo del sistema o alterar cualquier
                        información, así como el uso de bots, sistemas
                        automatizados o cualquier otra tecnología de
                        participación que no correspondan a un resultado dentro
                        de la capacidad humana.
                      </p>
                    </div>
                    <br clear="all" />
                    <div>
                      <p>
                        ● El <strong>ORGANIZADOR</strong>se reserva de manera
                        expresa el derecho de descalificar a cualquier
                        Participante del cual se tenga duda o sospecha que se
                        encuentra interviniendo en el correcto desarrollo de la
                        <strong>PROMOCIÓN</strong>de acuerdo con estas bases.
                      </p>
                      <p>
                        ● El <strong>ORGANIZADOR</strong>y sus filiales se
                        reservan el derecho de limitar o prohibir la
                        participación en esta
                        <strong> PROMOCIÓN </strong>
                        a cualquier persona, en el caso de presumir la
                        existencia de fraude o alteración en la
                        <strong>PROMOCIÓN</strong>, incluyendo de manera
                        enunciativa, más no limitativa, la mecánica de la misma,
                        los medios de pago, y cualesquiera otras que presuman la
                        existencia de fraude o alteración.
                      </p>
                      <p>
                        ● Cualquier intento, hecho por cualquier persona, de
                        dañar, alterar deliberadamente cualquier sitio de los
                        establecimientos Participantes relacionados con esta
                        <strong>PROMOCIÓN</strong>o alterar la legítima
                        operación de la misma, constituye una violación a las
                        leyes de carácter civil y penal; razón por la cual, en
                        caso de presentarse dicho intento, el
                        <strong>ORGANIZADOR</strong>; sus subsidiarias y/o
                        afiliadas, se reservan el derecho de reclamar
                        indemnización por daños y perjuicios frente a cualquier
                        persona, ante las autoridades y ejercer acciones legales
                        por la vía correspondiente.
                      </p>
                      <p>
                        ● No son elegibles para ser acreedores a los incentivos
                        de la
                        <strong>PROMOCIÓN</strong>los empleados y/o socios de
                        Grupo Pauta Creativa, S.A. de C.V., así como los
                        miembros de su familia, mencionando de forma enunciativa
                        más no limitativa, como “familia” al cónyuge, a los
                        padres, a los hermanos y a los hijos de los empleados.
                        Los empleados del <strong>PATROCINADOR</strong>o
                        filiales o subsidiarias que estén directamente
                        involucrados en la ejecución de la
                        <strong> PROMOCIÓN </strong>
                        , o áreas comerciales o los miembros de su familia no
                        son elegibles para ser designados acreedores a los
                        incentivos de la
                        <strong> PROMOCIÓN </strong>
                        , en la inteligencia de que por “familia” se entenderá
                        únicamente al cónyuge, a los padres, a los hermanos y a
                        los hijos de los empleados y/o socios de ambas empresas
                        en primer grado.
                      </p>
                      <p>
                        ● No serán considerados válidos aquellos registros antes
                        ni después de la vigencia de la
                        <strong>PROMOCIÓN</strong>. Solo participan los tickets
                        de compra con vigencia del 01 de octubre de 2025 al 07
                        de diciembre de 2025.
                      </p>
                      <p>
                        ● El <strong>ORGANIZADOR</strong>es el único responsable
                        y encargado de la ejecución y gestión de la
                        <strong>PROMOCIÓN</strong>, por lo qué, el
                        <strong>PATROCINADOR</strong>no tiene responsabilidad
                        alguna en caso de cualquier eventualidad que surja.
                      </p>
                      <p>
                        ● El Participante se obliga a proporcionar con veracidad
                        la información solicitada por el
                        <strong>ORGANIZADOR</strong>, en la inteligencia de que
                        en caso de que la información proporcionada por el
                        usuario sea falsa o incompleta, el
                        <strong>ORGANIZADOR</strong>se reserva el derecho de
                        suspender o cancelar su participación.
                      </p>
                      <p>
                        ● Las decisiones que se adopten respecto a la
                        <strong> PROMOCIÓN </strong>
                        serán finales y no se podrán apelar, en ninguna
                        circunstancia.
                      </p>
                      <p>
                        ● <u></u><u></u>Los Participantes se obligan a no
                        distribuir ninguna parte de la página promocional,
                        incluyendo a título enunciativo, mas no limitativo, los
                        archivos y demás información ingresados en el mismo a
                        través de ningún medio sin la previa autorización por
                        escrito del <strong>ORGANIZADOR</strong>y
                        <strong> COLGATE PALMOLIVE, S.A. de C.V. </strong>
                        así como a no alterar o modificar ninguna parte del
                        sitio web o plataforma de participación WhatsApp y sus
                        tecnologías relacionadas. No eludir, desactivar o
                        manipular de cualquier otra forma (o tratar de eludir,
                        desactivar o manipular) las funciones de seguridad de la
                        página web promocional u otras funciones que (i) impidan
                        o restrinjan su utilización. No utilizar el sitio para
                        ningún fin comercial, de publicidad, para realizar
                        alguna actividad comercial, artística, técnico o
                        profesional y/o con el fin principal de obtener
                        ingresos. No utilizar o activar ningún sistema
                        automatizado tendiente a modificar o copiar el contenido
                        del Sitio. No recabar datos personales de ningún usuario
                        de la cuenta o perfil de Facebook. <u></u>
                      </p>
                      <p>
                        ● El ganador deberá seguir en todo momento las
                        instrucciones para la entrega de su incentivo en la
                        fecha y lugar indicados, en caso de no hacerlo perderá
                        el derecho al mismo y no podrá haber reclamación alguna.
                      </p>
                      <p>
                        ● En caso de imposibilidad de ejecutar el incentivo por
                        cualquier motivo no aplica compensación o remuneración
                        alguna.
                      </p>
                    </div>
                    <br clear="all" />
                    <div>
                      <p>
                        ● Los Participantes ganadores deberán firmar la
                        totalidad de los documentos que se les solicite con
                        relación a la
                        <strong> PROMOCIÓN </strong>
                        , la negativa implica la renuncia al incentivo.
                      </p>
                      <p>
                        ● En caso de que sea imposible la localización de los
                        ganadores, con base en los datos registrados, el ganador
                        será descalificado y sustituido por el siguiente en la
                        lista de selección y así sucesivamente.
                      </p>
                      <p>
                        ● En caso de imposibilidad por parte de los ganadores,
                        de ejecutar el incentivo por cualquier motivo, con base
                        en los datos registrados, el Participante será
                        descalificado y sustituido por el siguiente en la lista
                        de selección y así sucesivamente.
                      </p>
                      <p>
                        ● Para poder tener acceso al incentivo, el Participante
                        deberá presentar una identificación oficial vigente y
                        que acredite la mayoría de edad (18 años).
                      </p>
                      <p>
                        ● Los incentivos serán entregados siempre y cuando se
                        haya validado la identidad del usuario con la
                        documentación solicitada.
                      </p>
                      <p>
                        ● Los ganadores deberán evitar en cualquier momento
                        conductas difamantes en la ejecución del incentivo.
                      </p>
                      <p>
                        ● La participación en esta <strong>PROMOCIÓN</strong>no
                        tendrá costo alguno.
                      </p>
                      <p>
                        ● El <strong>ORGANIZADOR</strong>, podrá en cualquier
                        momento suspender la <strong>PROMOCIÓN</strong>o la
                        entrega de incentivos sin responsabilidad alguna, si
                        dicha suspensión es un acto de cualquier orden
                        administrativa o judicial y/o si se dieren
                        circunstancias de caso fortuito o fuerza mayor o eventos
                        que afecten los intereses del organizador. Si por causas
                        ajenas al <strong>ORGANIZADOR</strong>se suspendiera,
                        modificara, alterara o de cualquier forma se vieran
                        imposibilitados los acreedores para recibir el
                        incentivo, el
                        <strong> ORGANIZADOR </strong>
                        , se reserva el derecho de otorgar opcionalmente algún
                        incentivo igual o similar al incentivo que el
                        Participante se hizo acreedor sin reducir sus
                        condiciones de uso. De igual forma se procederá en los
                        casos que existieran actos políticos, sociales o de
                        salud que hicieran inejecutables las entregas
                        respectivas de incentivos. En todos estos casos el
                        <strong>ORGANIZADOR</strong>publicará a través del sitio
                        los motivos en que se fundamente la realización de
                        cualquiera de los actos establecidos en el presente
                        párrafo.
                      </p>
                      <p>
                        ● El <strong>ORGANIZADOR</strong>; sus subsidiarias y/o
                        afiliadas no aceptan ninguna responsabilidad por
                        cualquier falla técnica o un funcionamiento defectuoso o
                        cualquier otro problema con la red que esté conectado en
                        línea al sistema, servidores, o proveedores de otro
                        tipo, que puede ser el resultado de cualquier contenido
                        o entrada en la <strong>PROMOCIÓN</strong>que no esté
                        correctamente registrado y los equipos y medios de
                        participación con sus costos corren a cuenta y cargo de
                        cada Participante.
                      </p>
                      <h1>19. CAUSAS QUE ANULAN LA PARTICIPACIÓN</h1>
                      <p align="left">
                        <strong></strong>
                      </p>
                      <p>
                        ● No participan personas menores de 18 años.
                        <strong></strong>
                      </p>
                      <p>
                        ● La falta de entrega de documentos (y tickets y/o
                        facturas originales de compra) que acrediten la
                        personalidad, la edad requerida en la
                        <strong>PROMOCIÓN</strong>y compra de los productos
                        Participantes dentro de las fechas condicionadas.
                        <strong></strong>
                      </p>
                      <p>
                        ● Asociar o exhibir a Colgate Palmolive, S.A. de C.V. en
                        la participación en temas relacionados a instituciones
                        políticas, religiosas, características o tópicos
                        sexuales o de incitación al consumo de enervantes o
                        bebidas etílicas, y/o violencia de cualquier índole y/o
                        discriminación.
                      </p>
                      <p>
                        ● Se anulará la participación si se presenta en el
                        material agresión de cualquier tipo hacia cualquier
                        sector y/o persona.
                      </p>
                      <p>
                        ● La presentación de tickets de compra que no cumplan
                        con los requisitos de la <strong>PROMOCIÓN</strong>.
                      </p>
                      <p>
                        ● Se anulará la participación si se presenta en el
                        material la presencia de alguna otra marca que no sea la
                        de
                        <strong> COLGATE PALMOLIVE, S.A. DE C.V. </strong>
                      </p>
                      <p>
                        ● Anulará la participación si existe negativa del
                        Participante a otorgar la autorización de uso de datos
                        personales, cesión de derechos y/o contenidos e imagen.
                      </p>
                    </div>
                    <br clear="all" />
                    <div>
                      <p>
                        ● En caso de haber resultado acreedor a algún incentivo
                        violentando las bases y condiciones de participación se
                        deberá de restituir el mismo al
                        <strong>ORGANIZADOR</strong>y responderán contra daños y
                        perjuicios.
                      </p>
                      <p>
                        ● Cualquier ataque o intento de alteración o
                        manipulación al sistema informativo, o a la página web o
                        al lugar en el cual se encuentre radicada la
                        <strong>PROMOCIÓN</strong>, genera la anulación de la
                        participación inmediata del Participante.
                      </p>
                      <p>
                        ● Presentar en la cuenta de registro datos de
                        instituciones políticas, religiosas, características o
                        tópicos sexuales o de incitación al consumo de
                        enervantes o bebidas etílicas, y/o violencia de
                        cualquier índole tales como discriminación.
                      </p>
                      <p>
                        ● Asimismo se prohíbe descargar materiales con palabras
                        altisonantes que agredan la integridad moral de
                        cualquier persona física o moral, así como el uso de
                        vocablos que insulten las buenas costumbres sociales,
                        malintencionado, material pornográfico, de actividades
                        ilegales o peligrosas de abusos a animales, consumo de
                        drogas o fabricación de materiales peligrosos,
                        violencia, etc.
                      </p>
                      <p>
                        ● Agresión o presencia de alguna otra marca de productos
                        cosméticos e higiene que no sean de la marca
                        <strong> COLGATE PALMOLIVE S.A. DE C.V. </strong>
                      </p>
                      <p align="left">
                        ● Utilizar Avisos Comerciales, Marcas Registradas, Obra
                        artística con reservas o derechos reservados de
                        terceros, ya sea de forma total o parcial, expresa o en
                        grado de confusión o difamación.
                      </p>
                      <p align="left">
                        ● Los acreedores deberán evitar en cualquier momento
                        realizar conductas difamantes u ofensivas dentro del
                        desarrollo de la
                        <strong> PROMOCIÓN </strong>
                        ..
                      </p>
                      <p align="left">
                        ● Los Participantes que se dediquen a perpetuar en las
                        promociones para fines ilícitos y desventajosos que
                        delimiten la participación de las demás interesadas.
                      </p>
                      <p>
                        ● Serán nulos automáticamente y no tienen derecho a
                        incentivo, tickets de compra o facturas que presenten
                        cualquier tipo de falsificación, alteración y/o
                        raspadura, re-marcación y/o enmendadura voluntaria y/o
                        involuntaria, ya sea por abrasión, fricción o
                        reimpresión de cualquiera de los elementos contenidos en
                        el interior de los mismos que no se encuentren
                        registrados en las tiendas mayoristas Participantes. En
                        caso de que sea ilegible la lectura del contenido de los
                        impresos, aun cuando la causa de la misma provenga de
                        origen, serán nulos los impresos respectivos.
                      </p>
                      <p>
                        ● Los Participantes que se dediquen a perpetuar en las
                        promociones para fines ilícitos y desventajosos que
                        delimiten la participación de las demás interesadas.
                      </p>
                      <p align="left">
                        Quienes realicen cualquiera de estas conductas,
                        responderá por daños y perjuicios de forma incondicional
                        ante quienes reclamen acción de cualquier índole por tal
                        situación.
                      </p>
                      <h1>20. GARANTÍA DE LOS INCENTIVOS:</h1>
                      <p>
                        La garantía de los incentivos ofrecidos se hará válida
                        conforme a las condiciones que cada proveedor y/o
                        fabricante ofrezca dentro de la documentación contenida
                        en los empaques o términos de uso, el responsable de la
                        validación de garantía estará a cargo únicamente del
                        <strong>ORGANIZADOR</strong>.
                      </p>
                      <h1>21. CASO FORTUITO O FUERZA MAYOR:</h1>
                      <p>
                        El <strong>ORGANIZADOR</strong>podrá en cualquier
                        momento suspender la <strong>PROMOCIÓN</strong>o la
                        entrega de incentivos sin responsabilidad alguna, si
                        dicha suspensión es en acato de cualquier orden
                        administrativa o judicial y/o si se dieren las
                        circunstancias de caso fortuito o fuerza mayor o eventos
                        que afecten los intereses del
                        <strong> ORGANIZADOR</strong>. Si por causas ajenas al
                        <strong> ORGANIZADOR </strong>
                        se suspendiera, modificara, alterara o de cualquier
                        forma se vieran imposibilitados los acreedores para
                        recibir el incentivo, el
                        <strong> ORGANIZADOR </strong>
                        , se reserva el derecho de otorgar opcionalmente algún
                        incentivo igual o similar al incentivo que el
                        Participante se hizo acreedor. De igual forma se
                        procederá en los casos que existieran actos políticos,
                        sociales o de salud que hicieran inejecutables las
                        entregas respectivas de incentivos. En todos estos casos
                        el
                        <strong>ORGANIZADOR</strong>publicará a través del sitio
                        los motivos en que se fundamenta la realización de
                        cualquiera de los actos establecidos en el presente
                        párrafo. En ningún momento el
                        <strong> ORGANIZADOR </strong>
                        o el <strong>PATROCINADOR</strong>serán responsables por
                        los acontecimientos que de esta devengan.
                      </p>
                    </div>
                    <br clear="all" />
                    <div>
                      <h1>22. PAGO DE IMPUESTOS</h1>
                      <p>
                        Todos los impuestos derivados de la obtención de premios
                        derivados de la
                        <strong>PROMOCIÓN</strong>correrán a cargo del
                        <strong> ORGANIZADOR </strong>
                        .
                      </p>
                      <h1>23. AUTORIZACIÓN DE USO DE DATOS, OBRA E IMAGEN:</h1>
                      <p>
                        Al momento de aceptar participar en la presente
                        actividad promocional, el Participante cede los derechos
                        morales y patrimoniales de uso de imagen
                        correspondientes al <strong>ORGANIZADOR</strong>y al
                        <strong> PATROCINADOR </strong>
                        para que éstas puedan utilizarlos para los fines que
                        decidan, además de su libre utilización, publicación y
                        difusión posteriormente y se obliga a realizar la
                        suscripción de los documentos pertinentes para alcanzar
                        tal fin.
                      </p>
                      <p>
                        De así requerirse, los acreedores se obligan a prestar
                        su imagen y/o voz para la elaboración de material
                        fotográfico, así como grabaciones de audio y video o
                        información y recopilación de datos a utilizarse en los
                        medios de comunicaciones que el
                        <strong>ORGANIZADOR</strong>y el
                        <strong>PATROCINADOR</strong>de la presente actividad
                        juzguen convenientes. Los testimoniales a que se hace
                        referencia en el párrafo anterior serán propiedad
                        exclusiva del <strong>ORGANIZADOR</strong>y del
                        <strong>PATROCINADOR</strong>los cuales podrá difundir y
                        utilizar de la manera que más convenga a sus intereses,
                        sin que esto implique pago alguno a dichos Participantes
                        por su aparición en cualquier medio de comunicación.
                      </p>
                      <h1>24. MEDIOS DE DIFUSIÓN</h1>
                      <p>
                        Las bases de la presente actividad se difundirán a
                        través de la página Web sitio web
                        <a href="https://www.datumax.com.mx/">
                          <u>https://www.datumax.com.mx</u>
                        </a>
                      </p>
                      <p>
                        Por lo antes mencionado, los Participantes y acreedores
                        están conformes en dar su autorización de manera
                        gratuita para que se use sus datos personales por parte
                        del <strong>ORGANIZADOR</strong>y el
                        <strong> PATROCINADOR </strong>
                        por el término de 5 (cinco) años, tiempo durante el cual
                        podrán éstas últimas usar las imágenes de manera libre
                        para la edición, distribución, difusión, explotación
                        comercial y distribución de las imágenes tomadas durante
                        la vigencia de la <strong>PROMOCIÓN</strong>, para
                        explotarlas por cualquier forma o medio incluyendo de
                        manera enunciativa más no limitativa, televisión,
                        internet, radio o cualquier medio electrónico, medios
                        externos de publicidad, tales como, parabuses, vallas,
                        espectaculares, entre otros, por el plazo de 5 (cinco)
                        años contados a partir de la fecha en que se inscriban a
                        la <strong>PROMOCIÓN</strong>el Participante,
                        transmisión de derechos patrimoniales de conformidad con
                        los artículos 30 y 31 de la Ley Federal del Derecho de
                        Autor, siempre y cuando el uso de las imágenes estén
                        relacionadas con la presente campaña.
                      </p>
                      <h1>25. AVISO DE PRIVACIDAD</h1>
                      <p align="left">
                        <strong></strong>
                      </p>
                      <p>
                        Grupo Pauta Creativa, S.A. de C.V. con domicilio en
                        Berlín, número 318, Colonia Del Carmen, Alcaldía
                        Coyoacán, Ciudad de México, México, C.P. 04100 y Colgate
                        Palmolive, SA. de C.V, son responsables de recabar sus
                        datos personales, del uso que se le dé a los mismos y de
                        su protección. En términos de lo previsto en la Ley
                        Federal de Protección de Datos Personales en Posesión de
                        los Particulares (en lo sucesivo denominada como la
                        “Ley”) y el Reglamento de la Ley Federal De Protección
                        de Datos Personales en Posesión de los Particulares (en
                        lo sucesivo el “Reglamento”), le pedimos que lea
                        cuidadosamente los términos y condiciones contenidos en
                        el presente Aviso de Privacidad, pues de no oponerse
                        expresamente al tratamiento de sus datos personales en
                        los Términos y Condiciones del presente se presume la
                        aceptación los mismos. El presente Aviso tiene por
                        objeto la protección de sus datos personales, mediante
                        su tratamiento legítimo, controlado e informado, a
                        efecto de garantizar su privacidad y su derecho a la
                        autodeterminación informativa. Su información personal
                        será solicitada a través del
                        <strong>ORGANIZADOR y el</strong>
                      </p>
                    </div>
                    <strong> <br clear="all" /> </strong>
                    <p>
                      <strong>PATROCINADOR</strong>para poder hacerlo partícipe
                      de dicha promoción, informarlo y en su caso contactarlo en
                      caso de resultar ganador, así como dar seguimiento a sus
                      preguntas, quejas, o comentarios.
                    </p>
                    <p>
                      El <strong>ORGANIZADOR</strong>y el
                      <strong>PATROCINADOR</strong>serán los Responsables de los
                      datos personales que nos haya proporcionado y se
                      compromete a tomar las medidas necesarias y suficientes
                      para garantizar que los términos del presente Aviso de
                      Privacidad sean respetados en todo momento por el
                      <strong>ORGANIZADOR</strong>y el
                      <strong> PATROCINADOR </strong>
                      y/o por aquellos encargados designados por el
                      <strong>ORGANIZADOR</strong>y el
                      <strong>PATROCINADOR,</strong>para recabar su información.
                      Los encargados designados por el
                      <strong>ORGANIZADOR</strong>y el
                      <strong> PATROCINADOR </strong>
                      asumirán las mismas obligaciones que corresponden al
                      <strong> ORGANIZADOR <em>y al</em>PATROCINADOR </strong>
                      como responsables. Nos comprometemos a no transferir su
                      información personal a terceros, salvo las excepciones
                      previstas en el artículo 37 de la Ley Federal de
                      Protección de Datos Personales en Posesión de los
                      Particulares, así como a realizar esta transferencia en
                      los términos que fija esa ley. El tratamiento de sus datos
                      personales será por un lapso de 5 años, pudiendo oponerse
                      al manejo de los mismos en cualquier momento que lo
                      considere oportuno.
                    </p>
                    <p>
                      De conformidad con el artículo 22 de La Ley, usted tiene
                      derecho de acceder a sus datos personales que poseemos y a
                      los detalles del tratamiento de los mismos, así como a
                      rectificarlos en caso de ser inexactos o incompletos;
                      cancelarlos cuando considere que no se requieren para
                      alguna de las finalidades señalados en el presente Aviso
                      de Privacidad, o bien, oponerse al tratamiento de los
                      mismos para fines específicos.
                    </p>
                    <p>
                      Para poder hacer ejercicio de dichos derechos usted podrá
                      acudir a las oficinas del <strong>ORGANIZADOR</strong>
                    </p>
                    <p>
                      ubicadas en: Berlín, número 318, Colonia Del Carmen,
                      Alcaldía Coyoacán, Ciudad de México, México,
                    </p>
                    <p>
                      C.P. 04100, y llenar el formato de solicitud ya sea para
                      el acceso, rectificación, cancelación u oposición de sus
                      datos personales que la Organizadora pone a su
                      disposición, y/o a través de escrito libre presentado en
                      las oficinas del <strong>ORGANIZADOR</strong>el cual
                      deberá contener la siguiente información:
                    </p>
                    <p align="left">
                      1. El nombre y domicilio del titular o cualquier otro
                      medio para recibir la respuesta.
                    </p>
                    <p align="left">
                      2. En caso de ser presentada a través de un representante,
                      los documentos que acrediten la identidad o la
                      personalidad de su representante.
                    </p>
                    <p align="left">
                      3. La descripción clara y precisa de los datos personales
                      respecto de los cuales el titular busca ejercer alguno de
                      los derechos.
                    </p>
                    <p align="left">
                      4. En su caso, otros elementos o documentos que faciliten
                      la localización de los datos personales
                    </p>
                    <p>
                      Si usted considera que su derecho de protección de datos
                      personales ha sido lesionado por alguna conducta de
                      nuestros empleados o de nuestras actuaciones o respuestas
                      o presume que en el tratamiento de sus datos personales
                      existe alguna violación a las disposiciones previstas en
                      la “Ley” y/o en el “Reglamento”, podrá interponer la queja
                      o denuncia correspondiente ante la Secretaría
                      Anticorrupción y Buen Gobierno. El
                      <strong> ORGANIZADOR </strong>
                      y el <strong>PATROCINADOR</strong>se reservan el derecho
                      de efectuar en cualquier momento modificaciones o
                      actualizaciones al presente aviso de privacidad, para la
                      atención de novedades legislativas, políticas internas o
                      nuevos requerimientos para la prestación u ofrecimiento de
                      nuestros servicios o productos, modificaciones que podrá
                      consultar a través de la página de la
                      <strong>PROMOCIÓN</strong>:
                      <a href="https://www.datumax.com.mx/">
                        <u>https://www.datumax.com.mx</u>
                      </a>
                    </p>
                    <h1>26. CONTACTO</h1>
                    <p>
                      Para la difusión de la información relacionada con la
                      <strong> PROMOCIÓN </strong>
                      , los únicos medios autorizados por el
                      <strong>ORGANIZADOR</strong>son el sitio web
                      <a href="https://www.datumax.com.mx/">
                        <u>https://www.datumax.com.mx</u>
                      </a>
                      , la plataforma de participación Chatbot de WhatsApp a
                      través de los links https://wa.link/pxun4f con número
                      5620292918 o https://wa.link/mtzlwe con número 5620298631
                      o al teléfono 55 3067 9927 en un horario de atención de
                      lunes a jueves de 9:00 a 18:00 horas y viernes de 9:00 a
                      15:00 horas horario Ciudad de México.
                    </p>
                  </div>
                </div>

                <div class="row py-5">
                  <div class="col-12 text-center pb-4 blanco zindex10">
                    &nbsp;
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="row py-5">
          <div class="col-12 text-center azul fXXG">GANADORES</div>
          <div class="col-12 text-center  azul fG py-2">Consulta la lista de ganadores semanales aquí:</div>
          <div class="col-12 text-center pb-5">
            <router-link
              to="/ganadores"
              class="amarillo pointer d-flex align-items-center justify-content-center btnaction fG ml-auto mr-auto w-100"
            >
              Lista de ganadores semanales
            </router-link>
          </div>
        </div> -->
      </div>
    </section>

    <PasswordReset
      v-if="showPasswordReset"
      @close="togglePasswordReset()"
    ></PasswordReset>

    <Footer></Footer>
  </div>
</template>

<script>
import PasswordReset from "@/components/PasswordReset";
import MonederoSet from "@/components/MonederoSet";

import Footer from "@/components/Footer";
import AOS from "aos";
import swal from "sweetalert2";

// import Parallax from "parallax-js";

import { mapState } from "vuex";
import moment from "moment";

import samsLogo from "../assets/imgs/flow/productos-participantes-sams.png";
import walmartLogo from "../assets/imgs/flow/productos-participantes-walmart.png";

import colgate1 from "../assets/imgs/datumax/productos/colgate-max-white.png";
import walmartPremios from "../assets/imgs/flow/premio-walmart.png";

import Vue from "vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
Vue.use(BootstrapVue);

export default {
  components: {
    PasswordReset,
    Footer,
  },
  data() {
    return {
      products: [
        {
          name: "Producto 1",
          description: "Este es el producto 1",
          image: "../assets/imgs/datumax/productos/colgate-max-white.png",
        },
        {
          name: "Producto 2",
          description: "Este es el producto 2",
          image: colgate1,
        },
        {
          name: "Producto 3",
          description: "Este es el producto 3",
          image: colgate1,
        },
        {
          name: "Producto 4",
          description: "Este es el producto 4",
          image: colgate1,
        },
      ],
      loginForm: {
        email: "",
        password: "",
      },
      signupForm: {
        nombre: "",
        apellido: "",
        email: "",
        celular: "",
        password: "",
        fecha_nacimiento: "",
        monedero: "",
        genero: "",
        terminosedad: "",
        terminos: "",
        terminoscondiciones: "",
        medio_de_contacto: "",
        estado: "",
      },
      showLoginForm: true,
      showPasswordReset: false,
      showMonedero: false,
      dateType: "text",
      explotar: true,
      showPasswordLogin: false, // Para login
      showPasswordSignup1: false, // Para signup password
      showPasswordSignup2: false, // Para signup confirm
    };
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation,
      disable: "mobile",
    });

    var scene = document.getElementById("scene");

    var vm = this;
    setTimeout(function () {
      vm.explotar = false;
      //var parallaxInstance = new Parallax(scene);
    }, 1000);
  },
  computed: {
    ...mapState(["userProfile"]),
    showNav() {
      return Object.keys(this.userProfile).length > 1;
    },
    logoSrc() {
      const tienda = process.env.VUE_APP_TIENDA;
      if (tienda === "sams") return samsLogo;
      if (tienda === "walmart") return walmartLogo;
      return "";
    },
    textoTienda() {
      const tienda = process.env.VUE_APP_TIENDA;
      if (tienda === "sams") return "Sam´s Club";
      if (tienda === "walmart") return "Walmart y Bodega Aurrera";
      return "";
    },
    groupedProducts() {
      const groups = [];
      for (let i = 0; i < this.products.length; i += 2) {
        groups.push(this.products.slice(i, i + 2));
      }
      return groups;
    },
  },
  methods: {
    cambiaFechaType() {
      this.dateType = "date";
      if (this.signupForm.fecha_nacimiento == "")
        this.signupForm.fecha_nacimiento = "1980-01-01";
    },
    toggleForm() {
      this.showLoginForm = !this.showLoginForm;
    },
    togglePasswordReset() {
      this.showPasswordReset = !this.showPasswordReset;
    },
    login(e) {
      e.preventDefault();

      this.$store.dispatch("login", {
        email: this.loginForm.email,
        password: this.loginForm.password,
      });

      // // // const https = require("https");
      // // // var qData = {
      // // //   email: this.loginForm.email,
      // // // };
      // // // this.$http
      // // //   .post(
      // // //     process.env.VUE_APP_API_URL + "login.php",
      // // //     JSON.stringify(qData),
      // // //     {
      // // //       emulateJSON: true,
      // // //       httpsAgent: new https.Agent({ rejectUnauthorized: false }),
      // // //       headers: {
      // // //         "Content-Type": "text/plain",
      // // //         //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
      // // //       },
      // // //     }
      // // //   )
      // // //   .then(
      // // //     (response) => {
      // // //       // get body data
      // // //       console.log("envio mail");
      // // //       console.log(response);

      // // //       let res = response.body;

      // // //       if (res.status == "ok") {
      // // //         this.$store.dispatch("login", {
      // // //           email: this.loginForm.email,
      // // //           password: this.loginForm.password,
      // // //         });
      // // //       } else {
      // // //         swal.fire("Oops", res.msg, "warning");
      // // //       }
      // // //     },
      // // //     (error) => {
      // // //       // error callback
      // // //       console.log("error callback");
      // // //       console.log(error);
      // // //     }
      // // //   );
    },
    signup(e) {
      e.preventDefault();

      // Validar contraseña
      if (this.validPass(this.signupForm.password) === false) {
        swal.fire(
          "Oops",
          "La contraseña debe tener al menos 8 dígitos",
          "warning"
        );
        return false;
      }

      // Confirmación de contraseña
      if (this.signupForm.password !== this.signupForm.password2) {
        swal.fire(
          "Oops",
          "La confirmación de contraseña no coincide con el campo de contraseña.",
          "warning"
        );
        return false;
      }

      // Validar teléfono
      if (this.validPhone(this.signupForm.celular) === false) {
        swal.fire(
          "Oops",
          "El celular debe ser un número válido de 10 dígitos.",
          "warning"
        );
        return false;
      }

      // Validar edad (18 años o más)
      if (!this.signupForm.fecha_nacimiento) {
        swal.fire("Oops", "Debes ingresar tu fecha de nacimiento.", "warning");
        return false;
      }

      const fechaNacimiento = moment(
        this.signupForm.fecha_nacimiento,
        "YYYY-MM-DD"
      );
      const hoy = moment();
      const edad = hoy.diff(fechaNacimiento, "years");

      if (edad < 18) {
        swal.fire(
          "Oops",
          "Debes tener al menos 18 años para registrarte.",
          "warning"
        );
        return false;
      }

      // Todo validado, registrar
      this.registro();
    },

    async registro(monedero = "") {
      this.$store.dispatch("showLoader", true);

      console.log({ registro: this.signupForm });

      // // // await this.enviaCorreo(
      // // //   this.signupForm.nombre,
      // // //   this.signupForm.apellido,
      // // //   this.signupForm.email
      // // // );

      await this.$store.dispatch("signup", this.signupForm);
    },
    async enviaCorreo(nombre, apellido, email) {
      //LLAMAR ENVIO DE CORREO
      let thes = this;
      const https = require("https");
      var qData = {
        nombre: nombre,
        apellido: apellido,
        email: email,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "registro-prueba.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            console.log("envio mail");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              await this.$store.dispatch("signup", thes.signupForm);

              thes.$gtag.event("conversion", {
                send_to: "AW-978746627/-5dyCPTN_-IBEIP62dID",
              });

              //window.fbq("track", "CompleteRegistration");

              this.resetForm();
              this.toggleForm();
            } else {
              swal.fire("Oops", res.msg, "warning");
              this.resetForm();
              this.toggleForm();
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
          }
        );
    },
    resetForm() {
      this.signupForm = {
        nombre: "",
        apellido: "",
        email: "",
        celular: "",
        password: "",
        fecha_nacimiento: "",
        monedero: "",
        terminosedad: false,
        terminos: false,
        terminoscondiciones: false,
      };
    },
    validPass(password) {
      if (password.length < 8) {
        return false;
      }
      return true;
    },
    validPhone(celular) {
      if (celular.length < 10) {
        return false;
      }
      if (isNaN(celular)) {
        return false;
      }

      return true;
    },
  },
};
</script>
